import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {UnitConversionModel} from '../models/unit-conversion.model';
import {UnitService} from '../../units/unit.service';
import {ManufacturingItemModel} from "../../../manufacturing/models/manufacturing-item.model";
import {ManufacturingItemGroupModel} from "../../../manufacturing/models/manufacturing-item-group.model";

@Component({
  selector: 'mes-web-unit-conversions-edit',
  templateUrl: './unit-conversions-edit.component.html'
})
export class UnitConversionsEditComponent implements OnInit {
  @Input() container: ManufacturingItemModel | ManufacturingItemGroupModel;
  @Input() class: string;
  @Input() readonly: boolean
  @Output() changed = new EventEmitter<boolean>();

  constructor(public unitService: UnitService) { }

  ngOnInit() {
  }

  remove(unitConversion: UnitConversionModel) {
    this.container.UnitConversions = [...this.container.UnitConversions.filter(value => value !== unitConversion)];
    this.changed.emit();
  }

  add() {
    this.container.UnitConversions = [...this.container.UnitConversions, new UnitConversionModel()];
    this.changed.emit();
  }
}
